import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import Screen from "@bd-utils/screen";
import Storage from "@bd-utils/storage";
import GameLogic from "@bd-core/game-logic";
import { getCurrentPageId } from "@bd-stores/user-progress";

export default class BD_Component {
    constructor() {
        this._data = {};

        /**
         * @type {BD_ComponentEvents}
         */
        this._events = null;
        this._registeredEvents = [];

        /* Change this to true if your block requires server-side data */
        this._serverSide = false;

        //add current component to component list
        bdjs.registerComponent(this);
    }

    // NOTE: this is just a placeholder hooks that can be used later in the code
    beforeInit() {}
    afterInit() {}
    beforeDestroy() {}
    afterDestroy() {}

    _setData(data) {
        this._data = Object.assign({}, data);
    }

    init() {
        window.screenCalculationFunc = () => Screen.calculateCoverSize();

        this.roomId = getCurrentPageId();

        if (this.beforeInit) this.beforeInit();
        this.registerEvents();
        if (this.afterInit) this.afterInit();

        /* Open room briefing for the first time */
        this._maybeOpenBriefing();

        /* play audio challenge for the first time */
        this._maybePlayAudioChallenge();
    }

    destroy() {
        if (this.beforeDestroy) this.beforeDestroy();
        this.deregisterEvents();
        if (this.afterDestroy) this.afterDestroy();
    }

    registerEvents() {
        if (!Array.isArray(this._events)) return false;

        const self = this;
        this._events.map((item) => {
            /**
             * NOTE: don't use arrow function, because we want to pointing
             * _this_ to the jQuery element itself
             * @param {Event} e
             */
            const handler = function (e) {
                item.handler.call(self, e, $(this), item.params);
            };

            this._registeredEvents.push(handler);

            if (document == item.selector) {
                $(document).on(item.event, handler);
            } else {
                const selector = /** @type {string} */ (item.selector);
                $(document).on(item.event, selector, handler);
            }
        });
    }

    deregisterEvents() {
        if (!Array.isArray(this._events)) return false;
        this._events.map((item, i) => {
            const handler = this._registeredEvents[i];

            // if (document == item.selector) { $(document).off(item.event, handler); return; }
            // $(document).off(item.event, item.selector, handler);

            if (document == item.selector) {
                $(document).off(item.event, handler);
            } else {
                const selector = /** @type {string} */ (item.selector);
                $(document).off(item.event, selector, handler);
            }
        });

        this._registeredEvents = [];
    }

    _maybeOpenBriefing() {
        if (!this._data?.room_id) return;
        const roomId = this._data.room_id;
        let states = Storage.get("states", {});
        if (!states?.briefing) states.briefing = [];

        const hasSeen = states.briefing.includes(roomId);
        if (!hasSeen) {
            states.briefing.push(roomId);
            Storage.set("states", states);
        } else {
            return;
        }

        GameLogic.toggleBriefing();
    }

    _maybePlayAudioChallenge() {
        if (!this._data?.room_id) return;
        const roomId = this._data.room_id;
        let states = Storage.get("states", {});
        if (!states?.audioChallenge) states.audioChallenge = [];

        if (!states.audioChallenge.includes(roomId)) {
            GameLogic.playAudioChallenge();
        }
    }
}
